import styled from "styled-components";
import { FadeInAnimation } from "src/apps/components/fadeIn/FadeInAnimation";
import { MediumText } from "src/apps/components/typography/Texts";
import { colors, Icon } from "@permisso/permisso-components";
import { ReactNode } from "react";

interface InlineWarningProps {
  message: string;
  icon?: ReactNode;
}

export const InlineWarning = ({
  message,
  icon = <Icon name="triangle-alert" size="s24" color="darkRed" />,
}: InlineWarningProps) => {
  return (
    <FadeInAnimation duration={0.4}>
      <WarningContainer>
        {icon}
        <MediumText $color={colors.grey800}>{message}</MediumText>
      </WarningContainer>
    </FadeInAnimation>
  );
};

const WarningContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.6875rem;
  width: 100%;
  padding: 0.75rem;
  border: 0.0625rem solid ${colors.darkRed};
  border-radius: 0.25rem;
  background-color: ${colors.lightRed};
`;
